export default __webpack_public_path__ + "static/media/gallery-image-3-full.2fde72ed.jpg";